<template>
  <div class="bodys" v-if="body_show">
    <div class="mclist_top clearfix">
      <ul>
        <li @click="buystatus=2" :class="buystatus==2?'buystatus':''">全部</li>
        <li @click="buystatus=0" :class="buystatus==0?'buystatus':''">待支付</li>
        <li @click="buystatus=1" :class="buystatus==1?'buystatus':''">已购买</li>
      </ul>
    </div>
    <div class="mclist_main" v-if="list.length>0">
      <ul>
        <li v-for="(item,index) in list" :key="index" v-show="item.buystatus==buystatus || buystatus == 2" class="clearfix">
          <h2>
          <router-link :to="'/course_details?bid='+item.pid">
              <b>{{item.course_name}}</b>
              <img src="@a/href.png" />
              <span v-if="item.buystatus!=1 && !item.refunding && item.surplus_time>1">支付剩余时间{{item.time}}</span>
              <span v-else>{{item.state}}</span>
            </router-link>
          </h2>
          <router-link :to="'/my_course_details?id='+item.id" class="course clearfix">
            <img :src="item.promotionimg" alt="" />
            <div class="course_fg">
              <h3>{{item.undetermined ==1?'待定':item.name}}</h3>
              <div v-if="item.undetermined == 0">
                <div v-if="item.start">
                  <h4 v-if="item.end==0">{{item.begin_time}} 结营</h4>
                  <h4 v-else>已结营</h4>
                </div>
                <h4 v-else>{{item.begin_time}} 正式开课</h4>
              </div>
            </div>
            <span class="sp1">￥ {{item.course_price}}</span>
            <span class="sp2" v-if="item.refunding">{{item.refund_success?'退款成功':'退款中'}}</span>
          </router-link>
          <div v-if="item.refunding" class="rk clearfix">
            <a v-if="item.refund_success" @click="remoreClick(item.id)">删除订单</a>
          </div>
          <div class="rk clearfix" v-else>
            <router-link :to="'/my_course_details?id='+item.id" v-if="item.buystatus!=1">去付款</router-link>
            <div v-else>
              <span v-if="item.click_num==0">
                <router-link :to="'/information?cid='+item.cid" v-if="!item.info">填写资料</router-link>
                <a v-else class="over">填写资料</a>
                <router-link :to="'/mentor_wechat?cid='+item.cid" :class="item.wecaht?'cf':''">添加微信</router-link>
              </span>
              <span v-if="item.start">
                <span v-if="item.info && item.wecaht">
                  <router-link :to="'/list?cid='+item.cid" v-if="item.click_num>0" :class="item.end==0?'':'cf'">{{item.end==0?"去上课":"重做项目"}}</router-link>
                  <a @click="addClick(item.id,item.cid)" v-else>开始上课</a>
                </span>
              <a @click="alert_show=true" v-else>开始上课</a>
              </span>
              <a v-else class="ov">开始上课</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="empry" v-else>
      <img src="@a/empry.png" alt="" />
      <p>暂无课程相关订单</p>
      <router-link to="/course_details?bid=1">我要学习</router-link>
    </div>
    <!-- 确认提交弹窗 -->
    <van-popup class="pub_alert" v-model="alert_show">
      <div class="confirm_box">
        <h2>您的课前任务“填写资料”和“添加班主任”还未完成</h2>
        <h3>完成以上课前任务在开始上课吧！</h3>
        <div class="btn_group">
          <a class="cancel" href="javascript:;" @click="alert_show=false">OK</a>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  mc_list,
  mc_goToClass,
  mc_delOrder
} from "@/api/person"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        list: [],
        buystatus: 2,
        clearInters: [],
        alert_show: false
      };
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        mc_list().then(data => {
          for (let arg of data) {
            arg['time'] = '00:00:00';
          };
          this.list = data;
          this.body_show = true;
          this.$toast.clear();
          for (let [index, arg] of data.entries()) {
            if (arg.buystatus == 0) {
              this.timeTostring(this.list[index]);
            }
          };
        });
      },
      addClick(id, cid) {
        mc_goToClass({
          id: id
        }).then(data => {
          this.$router.push({
            path: '/list',
            query: {
              'cid': cid
            }
          })
        });
      },
      remoreClick(id) {
        mc_delOrder({
          id: id
        }).then(data => {
          this.$toast("删除成功！");
          this.pullData();
        });
      },
      // 当前时间的格式化字符串
      timeTostring(obj) {
        if (obj.surplus_time > 0) {
          let sin = setInterval(() => {
            var secondTime = parseInt(obj.surplus_time); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
              //获取分钟，除以60取整数，得到整数分钟
              minuteTime = parseInt(secondTime / 60);
              //获取秒数，秒数取佘，得到整数秒数
              secondTime = parseInt(secondTime % 60);
              //如果分钟大于60，将分钟转换成小时
              if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
              }
            }
            var result = ((secondTime < 10) ? "0" : "") + parseInt(secondTime);

            if (minuteTime > 0) {
              result = ((minuteTime < 10) ? "0" : "") + parseInt(minuteTime) + ":" + result;
            }
            if (hourTime > 0) {
              result = ((hourTime < 10) ? "0" : "") + parseInt(hourTime) + ":" + result;
            }
            obj.time = result;
            obj.surplus_time -= 1;
          }, 1000);
          this.clearInters.push(sin);
        } else {
          clearInterval(sin)
        }

      }
    },
    created() {
      this.pullData();
      shareCon("index", this);
    },
    destroyed() {
      for (let args of this.clearInters) {
        clearInterval(args)
      }
    }
};
</script>
<style lang="scss" scoped>
.mclist_top {
  margin-top: 30px;
  text-align: center;
  ul li {
    color: #999;
    font-size: 28px;
    margin: 0 53px;
    padding-bottom: 14px;
    border-bottom: 4px solid #f0f0f0;
    display: inline-block;
  }
  .buystatus {
    border-bottom-color: #EB5032;
    color: #EB5032;
  }
}

.empry {
  margin-top: 287px;
  text-align: center;
  img {
    width: 180px;
  }
  p {
    margin-top: 30px;
    font-size: 26px;
    color: #999;
  }
  a {
    width: 170px;
    height: 66px;
    background: rgba(235, 80, 50, 1);
    border-radius: 33px;
    display: inline-block;
    font-size: 34px;
    color: #fff;
    line-height: 66px;
    margin-top: 50px;
  }
}

.mclist_main {
  padding: 0 30px;
  ul li {
    width: 690px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 20px;
    margin-top: 20px;
    h2 {
      padding-bottom: 10px;
      border-bottom: 2px solid #ccc;
      color: #333;
      font-size: 28px;
      a {
        display: block;
        width: 100%;
        height: 100%;
        color: #333;
        img {
          display: inline-block;
          width: 26px;
          vertical-align: inherit;
          margin-left: 10px;
        }
        span {
          float: right;
          color: #EB5032;
          font-size: 24px;
          margin-top: 2px;
        }
      }
      b {
        width: 320px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: normal;
        display: inline-block;
      }
    }
    .course {
      display: block;
      margin-top: 20px;
      position: relative;
      .course_fg {
        width: 280px;
        float: left;
        margin-left: 20px;
        h3 {
          color: #333;
          font-size: 26px;
        }
        h4 {
          color: #999;
          font-size: 24px;
        }
      }
      img {
        width: 200px;
        float: left;
      }
      span.sp1 {
        color: #333;
        font-size: 26px;
        float: right;
      }
      span.sp2 {
        color: #F57F17;
        font-size: 24px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .rk {
      margin-top: 30px;
      text-align: right;
      a {
        width: 134px;
        height: 48px;
        background-color: #EB5032;
        color: #fff;
        border-radius: 24px;
        font-size: 24px;
        line-height: 48px;
        text-align: center;
        margin-left: 10px;
        display: inline-block;
      }
      .over {
        background-color: #CCCCCC;
        border-color: #CCCCCC;
        color: #fff;
      }
      .cf {
        border: 2px solid rgba(235, 80, 50, 1);
        color: #EB5032;
        background-color: #fff;
      }
      .ov {
        border: 2px solid #ccc;
        color: #ccc;
        background-color: #fff;
      }
    }
  }
}

.confirm_box h2 {
  padding: 25px 20px;
  padding-bottom: 10px
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box .btn_group a.cancel {
  width: 100%;
  color: #EB5032
}
</style>
